module.exports = __webpack_public_path__ + "img/logo-blue.adee2dbb.png";